<template>
  <transition name="el-fade-in-linear">
    <div class="calender-schedule-media-component">
      <hi-dialog
        title="Apphi Library"
        @close="close()"
        class="media-library-dialog"
      >
        <div style="flex: 1; overflow: auto" id="apphi-library-modal">
          <div class="library-image-container">
            <div
              @click="selectMedia(image)"
              :class="{ select: image.select }"
              :key="image.id"
              v-for="image in libraries"
              v-lazy:background-image="image.coverUrl"
              class="image"
            >
              <div v-if="image.type === 2" class="video-icon"></div>
              <div class="icon"></div>
            </div>
          </div>
          <div style="width: 100%; padding: 20px; text-align: center">
            <el-button
              v-show="!mediaListLoading && !mediaLibraryList.end"
              size="mini"
              style="width: 100%"
              @click="loadMoreMedia()"
              >Load more</el-button
            >
            <div
              v-show="mediaLibraryList.end"
              style="color: rgb(140, 140, 140)"
            >
              end
            </div>
            <div v-show="mediaListLoading">
              <i class="el-icon-loading"></i> Loading
            </div>
          </div>
        </div>
        <div class="bottom-container">
          <upload-btn target="#apphi-library-modal">
            <hi-button type="text">Upload</hi-button>
          </upload-btn>
          <hi-button @click.native="saveSelect">Select</hi-button>
        </div>
      </hi-dialog>
    </div>
  </transition>
</template>
<style lang="less">
.dragClass {
  background: black;

  .image {
    opacity: 1 !important;
  }
}
</style>
<style lang="less" scoped>
@import "../../../../assets/style/theme";

.calender-schedule-media-component {
  .media-library-dialog {
    width: 374px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    height: 730px;

    .back-icon {
      width: 24px;
      height: 24px;
    }

    .library-image-container {
      display: flex;
      overflow: auto;
      width: 374px;
      flex-wrap: wrap;

      .image {
        width: 124px;
        height: 124px;
        margin-bottom: 1px;
        margin-right: 1px;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .video-icon {
          width: 55px;
          height: 55px;
          z-index: 2;
          background-size: cover;
          background-image: url("../../../../../public/images/schedule_posts/list/video.png");
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        .icon {
          border: 1px solid white;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          position: absolute;
          bottom: 10px;
          right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        &.select .icon {
          background-size: contain;
          background-image: url("../../../../../public/images/library/Select@3x.png");
          width: 23px;
          height: 23px;
          border: 0;
        }
      }
    }

    .bottom-container {
      padding: 0 20px;
      height: 64px;
      border-top: 1px solid #e5e5e5;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .upload-menu {
      position: absolute;
      left: 5px;
      bottom: 45px;
      background: white;
      border-radius: 3px;
      padding: 5px 0;

      &:after,
      &:before {
        left: 17%;
      }

      .item {
        display: flex;
        align-items: center;
        padding: 12px;
        cursor: pointer;

        .title {
          font-size: 14px;
          white-space: nowrap;
          margin-left: 10px;
        }

        i {
          font-size: 16px;
        }

        &:last-child {
          margin-bottom: 0;
        }

        &:hover {
          background: @color-primary;
          color: white;
        }
      }
    }
  }
}
</style>

<script>
import hiDialog from "../../../common/dialog/Index.vue";
import hiButton from "../../../common/button/Index";
import { loadMore } from "../../../../service/media";
import { mapGetters } from "vuex";
import { MEDIA_LIBRARY_LIST } from "../../../../store/mutation-types";
import { showErrorMsg, initValidate } from "../../../../utils/errors";
import uploadBtn from "../../../library_menu/UploadBtn";
export default {
  name: "CalenderScheduleMediaComponent",
  components: { hiDialog, hiButton, uploadBtn },
  props: {
    hasLink: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * 关闭点击事件
     */
    close() {
      if (this.only) {
        this.$parent.close();
      }
      this.$parent.showOnlyMediaModal = false;
    },
    /**
     * 页面重新加载
     */
    async reload() {
      await loadMore({ first: true });
    },
    async selectMedia(m) {
      if (m.type === 2 && !m.postVideo) {
        const msg = `Due to Instagram POST limitations, Apphi Desktop only supports .mp4 video format with ratios between 4:5 to 16:9. Video must be between 3 to 60 seconds. \n\nYou can use Apphi App to edit your video, change cover, schedule and upload directly.`;
        this.$bus.$emit("showDownload", { msg });
        return;
      }
      this.selectId = m.id;
    },
    /**
     * 加载media更多
     * @returns {Promise.<void>}
     */
    async loadMoreMedia(first) {
      try {
        this.mediaListLoading = true;
        await loadMore({ first });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.mediaListLoading = false;
      }
    },
    async saveSelect() {
      try {
        if (this.hasLink) {
          await Promise.reject(
            initValidate({
              msg: "You can‘t add your own media when you share link.",
            })
          );
        }
        this.$emit(
          "save",
          this.libraries.find((m) => m.select)
        );
      } catch (e) {
        showErrorMsg(e);
      }
    },
  },
  data() {
    return {
      mediaListLoading: false,
      selectId: 0,
      menus: [
        {
          // upload菜单
          id: "computer",
          image: "computer",
          text: "Upload From Computer",
        },
        {
          id: "dropbox",
          image: "dropbox",
          text: "Upload From Dropbox",
        },
        {
          id: "drive",
          image: "drive",
          text: "Upload From Google Drive",
        },
      ],
    };
  },
  computed: {
    only() {
      return !this.$parent.showMainFormModal;
    },
    ...mapGetters({
      mediaLibraryList: MEDIA_LIBRARY_LIST,
    }),
    /**
     * 计算图片选中状态
     * @returns {Array}
     */
    libraries() {
      if (!this.mediaLibraryList) return [];
      const libraries = this.mediaLibraryList.list.map((m) => {
        let media = {
          ...m,
        };
        media.select = m.id === this.selectId;
        return media;
      });
      return libraries;
    },
  },
};
</script>
